import { environment } from "../../../environments/environment";

export const ENABLE_TRADING_SIGNATURE = {
    "types": {
        "EIP712Domain": [
            {
                "name": "name", 
                "type": "string"
            },
            {
                "name": "chainId", 
                "type": "uint256"
            },
            {
                "name": "verifyingContract", 
                "type": "address"
            }
        ],
        "CreateProxy": [
            {
                "name": "paymentToken", 
                "type": "address"
            },
            {
                "name": "payment", 
                "type": "uint256"
            },
            {
                "name": "paymentReceiver", 
                "type": "address"
            }
        ]
    },
    "primaryType": "CreateProxy",
    "domain": {
        "name": "Polymarket Contract Proxy Factory",
        "chainId": 80002,
        "verifyingContract": environment.CONTRACT_ADDRESS
    },
    "message": {
        "paymentToken": "0x0000000000000000000000000000000000000000",
        "payment": 0,
        "paymentReceiver": "0x0000000000000000000000000000000000000000"
    }
}